import { Component,OnInit, ViewChild, AfterViewInit, OnDestroy,ElementRef,ChangeDetectorRef } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {Router } from '@angular/router';
import { DashboardService } from './service/dashboardservice';
import { UserProfile } from '../model/user-profile';
import {UserService} from '../commonservices/user.service';
import { AuthService } from '.././core/auth-service.component';
import {State, SortDescriptor, orderBy} from '@progress/kendo-data-query';
import {PageChangeEvent, GridDataResult} from '@progress/kendo-angular-grid';
import {NgbDateAdapter, NgbDateNativeAdapter,NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService} from '../core/localstorage-service';
import { InvoiceViewModel } from '../webresolution/model/InvoiceViewModel';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WebResService } from '../webresolution/service/webresservices';
import { InvoiceAttachmentsDTO } from "../webresolution/model/InvoiceAttachmentsDTO";
import {  Subject } from 'rxjs';
import { MultiRaterService } from '../multirater/service/multirater-service';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie';
import { UserSettings, Usertype } from 'src/app/model/UserSettings';
import { GlobalService } from '@global/global.service';
import { BaseChartDirective } from 'ng2-charts';
import { ChartOptions, ChartConfiguration, ChartType, Chart} from 'chart.js';
import { GridComponent } from '@progress/kendo-angular-grid';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { MessageBox } from '../commoncomponent/MessageBox/MessageBox';
import { ShareService } from '../commonservices/shared.service';
import { PageSizeItem } from "@progress/kendo-angular-grid";
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import * as XLSX from 'xlsx';
import Utils from '../helpers/Util';
import { AppService } from '@global/app.service';
import { DownloadFileModalComponent } from './modal/downloadFile.component';
import { switchMap, distinctUntilChanged, debounceTime, mergeMap, takeUntil ,concatMap, take } from 'rxjs/operators';

import { ViewAttachmentModalComponent } from '../webresolution/modal/viewAttachment.component';
import { AttachComponent } from '../commoncomponent/AttachComponent/attach.component';
import { SendCtGlobalModalComponent } from '../webresolution/modal/sendctglobal.component';
import { MessageToBeDirectedTo } from '../webresolution/helper/WebResEnums';
import { InvoiceFullDetailsViewModel } from '@models/InvoiceFullDetailsViewModel';

const others: Array<Number> = [ 100, 101, 102, 105, 107, 110, 113, 114, 115, 116, 117, 118, 119 ];

// declare var Chart;
const defaultDashboardValue = {
  client: null,
  currency: null,
  datePeriod: 'THIS_QUARTER'
}

interface SelectAll  {
  selectAll: boolean,
  data: any
}

@Component({
  templateUrl: './starter.component.html',
  styleUrls:['./starter.component.scss','./starter.component.css','./starter-new-template.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},DatePipe]
})

export class StarterComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(TooltipDirective,{static: false}) public tooltipDir: TooltipDirective;
  @ViewChild('invoiceGrid', { static: false }) invoiceGrid: GridComponent;
  @ViewChild('checkedGrid', { static: false }) checkedGrid: GridComponent;
  @ViewChild('chart', { static: true }) chart: BaseChartDirective;
  @ViewChild('grid', { static: false }) grid: GridComponent;
  @ViewChild('invoiceHistoryChart', { static: false }) invoiceHistoryChart: BaseChartDirective;
  @ViewChild('noimg', {static: false}) noimg: ElementRef;
  @ViewChild('invoicePDF', {static: false}) invoicePDF: ElementRef;
  dateFormat = 'yyyy/MM/dd';

  headerStyle: any = { color: '#fff'};

  isSeeAll:any = "isSee";
  public seeCollapse = true;
  public isCollapsedException = false;
  public isCollapsedExceptionKendoChart = false;
  public isCollapsedExceptionPiechart = false;
  public isCollapsedExceptionTreeMap = false;
  public isCollapsedCommentHistory = true;
  public isCollapsedExceptionComments = false;
  public isCollapsedExceptionInvoice = true;
  public UserType:string = "";
  public Approved:boolean = false;
  public showDownload:boolean = false;
  public isVisibleWebForm: boolean = false;
  seeAllHistory: boolean = true;
  public showList:boolean = true;
  public shipmentGridView: GridDataResult;
  public inv:InvoiceFullDetailsViewModel;

  public displayList: Array<any> = [{Code: 'display1', Name:'Display 1'}, {Code: 'display2', Name:'Display 2'}];
  public actionStyle:any = { 'background': '#ffffff',color: 'rgb(159, 160, 160)',cursor:'auto','pointer-events':'none' };
  public refreshStyle: any = { 'background': 'rgb(251, 251, 251)',color: 'rgb(159, 160, 160)' };
  public selectAllStyle:any = { 'background': 'rgb(251, 251, 251)',color: 'rgb(159, 160, 160)' };
  public exportStyleIcon:any = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
  public actionStyleIcon:any = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
  public clearFilterStyle:any = { 'background': '#ffffff',color: 'rgb(159, 160, 160)',cursor:'auto','pointer-events':'none' };
  public clearFilterStyleIcon:any = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
  public exportStyle: any = { 'background': '#ffffff',color: 'rgba(0, 0, 0, 0.39)'};
  private unsubscribe$ = new Subject<void>();
  public selectedDisplay: string = "display1";
  public selectedTempValue = this.displayList[this.displayList.length - 2];
  public invdata: Array<InvoiceViewModel>;
  public currencyItems: any;
  public dashboard: any;
  public barchartlabels: Array<any> = []
  public sortGrid: SortDescriptor[];
  _userProfile: UserProfile;
  public invsDataGrid:GridDataResult;
  public invoiceAttachment:Array<InvoiceAttachmentsDTO>;
  public downloadWindow: boolean = false
  public selectedItemCurrency:any;
  public selectedItemClient:any;
  public selectedItem:any;
  public gridPageSize:number = 10;
  public ngxConfig: any = {
    itemsPerPage: 10,
    totalItems: 0,
  }

  windowLeft = 50;
  filterInput: any = {
    carrierName: null,
    invoiceNumber: null,
    shipmentId: null,
    endDate: null,
    startDate: null,
    dateType: null,
    documentType: null
  };
  
  showDropList: boolean = false;

  //filter here
  public filterSearchWindow = false;
  public kendoPageSize = 10;
  public pageSize = 10;
  public checkedPageSize = 10;
  filterForm: UntypedFormGroup;
  //grid sorting here
   public invSortDropDownList: Array<any> = [
      {Code: 'invoiceDate', Name:'Invoice Date'},
      {Code: 'dueDate', Name:'Due Date'},
      {Code: 'client', Name:'Client'},
      {Code: 'carrier', Name:'Carrier'},
      {Code: 'invoiceAmount', Name:'Invoice Amount'},
      {Code: 'reasonCode', Name:'Reason Code'},
      {Code: 'currentStatusDays', Name:'Current status Days'},
      {Code: 'daysToDueDate', Name:'Days to Due Date'},
      {Code: 'NumberOfTimesInResolution', Name:'Number Of Times In Resolution'},
      {Code: 'DocumentType', Name:'Document Type'},
      {Code: 'InvoiceNo', Name:'Invoice Number'},
      {Code: 'NoOfShipment', Name:'No. Of Shipments'}
  ];

  public selectedItemInvSort:any;
  public placeHolderSort: any = {Code: 'Sort', Name:'Sort'};
  public selectedItemInvSortCopy:{Code: string, Name: string} = {Code: 'invoiceDate', Name:'Invoice Date'}
  public gridViewInvoiceSIDs: any;

  dashboardForm: UntypedFormGroup;
  checked: boolean = false;
  chartFormatType: Array<any> = [{data: 'Number of Invoices',index: 1}, {data: 'Value of Invoices',index: 2}];
  public selectedFormatValue = {data: 'Number of Invoices',index: 1}
  chartFormatValue = 1;

  filters: any;
  deepFilters: any;

  userType: Usertype;
  isVisible: boolean = false;
  actionVisible: boolean = false;
  filterVisible: boolean = false; 
  data: any;
  show:boolean = false;

  // public barOpenInvoiceChartOptions: any;  
  
  public barOpenInvoiceChartOptions: ChartConfiguration['options']  = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        
      },
      y: {
        stacked: true
        
      }
    },    
    plugins: {            
      legend: {
        display: false,
      },
      annotation: {
        drawTime: 'afterDatasetsDraw',
        annotations: [
            {
              type: "line",
              scaleID: "xAxis1",
              value: "2.5",
              borderColor: "#ffc1c9",
              label: {
                content: "",
                enabled: true,             
                backgroundColor: "#f4f6f9",
                position: "top",
                xAdjust: -50,
                yAdjust: 5
              }
            },
            {
              type: "line",
              scaleID: "xAxis1",
              value: "2.5",
              borderColor: "#ffc1c9",
              label: {
                content: "",
                enabled: true,
                backgroundColor: "#f4f6f9",
                position: "top",
                xAdjust: 50,
                yAdjust: 5
              }
            }
        ],
      }
    }    
  };

  invoicesList: any;
  gridView: GridDataResult;
  checkedGridView: GridDataResult;

  // bar chart
  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true
      },
      y: {
        stacked: true
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  };

  public invs:Array<InvoiceViewModel> = [];
  public invsCopy:Array<InvoiceViewModel>  = [];
  public barOpenInvoiceChartLabels: string[] = ['+30', '30-10', '10-0', '0-10','10-30','60+'];
  public OpenInvoiceAlias: string[] = ['', 'Current', '', '','','Overdue',''];
  public barOpenInvoiceChartTyp: ChartType = 'bar';
  public barOpenInvoiceChartLegend = false;
  public barOpenInvoiceChartColors: Array<any> = [{ backgroundColor: '#0F3F6F' },{ backgroundColor: '#25609b' }, { backgroundColor: '#19a0cb' }, { backgroundColor: '#6dc2c5' }, { backgroundColor: '#e63946' }];
  public browserRefresh: boolean = false;
  public stateInvs: State = { skip: 0, take: 5, sort:[] }
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartColors: Array<any> = [{ backgroundColor: '#6DC2C5' },{ backgroundColor: '#f53111' } ];
  columnDefs: any;
  roleClients: any;

  userSettings: UserSettings;
  loadDashboard: boolean = false;
  clickedRowItem: any;
  invoices: any;

  take = 10;
  skip = 0;
  status: string = 'OPEN';
  category: string = 'ALL';
  views: Array<string> = [];
  weekIndex = 0;
  year: string = '';
  monthAbbrev: string = '';
  sortOrderValue:string = 'ASC';
  columns: Array<string>;
  columnNames: Array<string>;

  filterText: Array<string>;
  filterTextArr: Array<string> = [];

  filterShipmentArr: Array<string> = [];

  //vars here
  public dataHistory: Array<{ CodeName: string, Name: string }> = [
      { CodeName: "THIS_MONTH", Name: "This Month" },
      { CodeName: "LAST_MONTH", Name: "Last Month" },
      { CodeName: "THIS_QUARTER", Name: "This Quarter" },
      { CodeName: "LAST_QUARTER", Name: "Last Quarter" },
      { CodeName: "THIS_YEAR", Name: "This Year" },
      { CodeName: "LAST_YEAR", Name: "Last Year" }
  ]; 

  public pageSizes: PageSizeItem[] = [   
    {  text: "10", value: 10,  },  
    {  text: "20", value: 20,  }, 
    { text: "50",  value: 50, }, 
    {  text: "100", value: 100, },
    {  text: "300", value: 300, }, 
    {  text: "All",  value: "all"},
  ];

  public listFilter:any =  [];
  public listFilterOpenGraph:any =  [];
  public listFilterCloseGraph:any =  [];
  public StatusCodes:any =  [];
  public listFilterOpenGraphCodes:any = [];
  public listFilterInvNos:any = [];
  public totalPage:number = 0;
  public grid2PageNo:number = 1;
  public gridPageNo:number = 1;
  public sort:any = {Code: 'invoiceDate', Name:'Invoice Date'};//default
  public allocation:string="";
  public invShipment: Array<any>;
  public showIframeLoader:boolean = false;
  public style:string;

  public invoiceGridHideSelectedColumn = {InvoiceNo:false,InvoiceDate:false,NoOfShipment:false,
    DueDate:false,ClientCode:false,ClientRegion:false,
    ClientCountry:false,ClientCity:true,ClientDivision:true,
    ClientLocation:true,CarrierCode:true,CarrierName:true,
    CarrierCity:false,CarrierCountry:false,Currency:false,
    BilledAmount:false,ShipmentMode:false,ServiceLevel:false,
    OriginCountryCode:false,DestinationCountryCode:false,ResolutionReasonCode:false}

  public iSSlectedAllChecked:boolean = false;
  public actionBtn = true; 
  public filterSearchStyle:any = { 'background': 'rgb(251, 251, 251)',color: 'rgb(159, 160, 160)'};
  public hasFilter: boolean = false;
  fileAttachment: any;
  comment: string;
  isVisibleShipment:boolean = false;
  public titleShipment: string;
  public shipmentInformation: any;
  public gridViewInvoiceSIDsCopy: any;
  public gridViewInvoiceClientFields:any;
  public gridViewInvoiceClientFieldsCopy: any;
  public gridViewInvoiceUoms: any;
  public gridViewInvoiceUomsCopy: any;

  ALL_STATUSCODES: Array<any> = ['OPEN', 'INPROG', 'INWEB', 'PASSED_AWAIT', 'REJECTED_AWAIT', 'PASSED', 'REJECTED', 'MYWEB'];
  
  constructor(
    private _dashBoardService: DashboardService,
    private _userService: UserService,
    private _authService: AuthService,
    private _cookieService: CookieService, 
    private fb: UntypedFormBuilder, 
    private _webResService: WebResService,
    private _messageBox: MessageBox,
    private _sharedService: ShareService,
    private _appService: AppService,
    private _cd: ChangeDetectorRef,
  ) {
    let namedChartAnnotation = pluginAnnotations;
    namedChartAnnotation["id"]="annotation";
    Chart.register( namedChartAnnotation);

    this._sharedService.clientCurrencyEmit$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {

      this.gridPageNo = 1;
      this.grid2PageNo = 1;

      this.dashboardForm.patchValue({
        client: data.client,
        currency: data.currency
      });
      this.refreshData();
    });
  }

  dInvoicesNo: string = '';
  dCarrierName: string = '';
  dShipmentId: string = '';
  dStartDate: Date;
  dEndDate: Date ;
  dDataTypes: string = '';
  dDocumentTypes: string = '';
  appmodule="Dashboard";

  showDashboard: boolean = false;

  windowInvoiceStatus: string = "";
  
  ngOnInit() {
      this.showDashboard = true;
      this.dashboardForm = this.fb.group(defaultDashboardValue);
      this.buildForm();
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit(){
    this._authService.getUserIdentity().then(user => {
      this.GET_USERSETTINGS();
    });
    
    //if selected in  navigation is change this will trigger
    this._sharedService.changeEmitted$.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      if(data.Type ==="Grid"){
        if(this.selectedDisplay !== data.Value){
          this.selectedDisplay = data.Value;
          this.selectedTempValue = this.displayList.filter(x=>x.Code == this.selectedDisplay)[0];
        }
      }
    }); 
  }
  
  buildFilters(){
    return {
      ClosedInvoicesPeriod  : this.dashboardForm.get('datePeriod').value,
      InvoiceNumbers        : this.listFilterInvNos,
      WeekIndex             : this.weekIndex,
      Currency              : this.dashboardForm.get('currency').value?.Code,
      Client                : this.dashboardForm.get('client').value,
      SortValue             : this.selectedItemInvSort,
      SortOrder             : this.sortOrderValue,
      Status                : this.status,
      StatusCodes           : this.GET_STATUS_CODES(),
      OpenInvGraphCodes     : (this.listFilterOpenGraph.length > 0) ? this.listFilterOpenGraph[0].Code : "",
      CloseInvGraphCodes    : (this.listFilterCloseGraph.length > 0) ? this.listFilterCloseGraph[0].Code : "",
      Take                  : this.take,
      Skip                  : this.skip,
    }
  }

  buildFiltersOnInit(){
    return {
      ClosedInvoicesPeriod  : this.dashboardForm.get('datePeriod').value,
      InvoiceNumbers        : this.listFilterInvNos,
      WeekIndex             : this.weekIndex,
      Currency              : (this.dashboardForm.get('currency').value)?.Code,
      Client                : this.dashboardForm.get('client').value,
      SortValue             : this.selectedItemInvSort,
      SortOrder             : this.sortOrderValue,
      Status                : this.status,
      StatusCodes           : ['OPEN','INPROG', 'INWEB', 'PASSED_AWAIT', 'REJECTED_AWAIT', 'PASSED','REJECTED','MYWEB' ],
      OpenInvGraphCodes     : (this.listFilterOpenGraph.length > 0)?this.listFilterOpenGraph[0].Code:"",
      CloseInvGraphCodes    : (this.listFilterCloseGraph.length > 0)?this.listFilterCloseGraph[0].Code:"",
      Take                  : this.take,
      Skip                  : this.skip,
    }
  }

  buildForm(){
    this.dashboardForm = this.fb.group(defaultDashboardValue);
    this.showDropList = true;

    this._webResService.getWebResUserType().pipe(takeUntil(this.unsubscribe$)).subscribe((userType) => {
      this.UserType = userType;
    });
  }

  refreshData(){
    this.SEARCH_DASHBOARD();
  }

  public onCloseFilter(filter, $event){
    filter.hidden = !(filter.hidden); 
    
    var statuses: Array<any> = this.dashboard?.BarSelected;
    var closedInvoices: Array<any> = this.dashboard?.barChartData;

    if(!statuses.some(e => e.hidden == false) && !closedInvoices.some(e =>e.hidden == false)){
      this.SEARCH_DASHBOARD(true);
    } else{
      this.SEARCH_DASHBOARD();
    }
    this.setClearFilterStyle();
  }

  public onCloseFilterClosedInvoices(filter){
    filter.hidden = !(filter.hidden); 
    var statuses: Array<any> = this.dashboard?.BarSelected;
    var closedInvoices: Array<any> = this.dashboard?.barChartData;

    if(!statuses.some(e => e.hidden == false) && !closedInvoices.some(e =>e.hidden == false)){
      this.SEARCH_DASHBOARD(true);
    } else{
      this.SEARCH_DASHBOARD();
    }
    this.setClearFilterStyle();
  }

  public onCloseFilterGraph(filter, $event){
    var scope = this;

    this.listFilterOpenGraph = scope.listFilterOpenGraph.filter(function(tabEl){
      return tabEl.id !== filter.id;
    })

    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboard(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
        this.totalPage = data.TotalInvoiceCount;
        this.invsDataGrid = {
          data: this.appendISCHECKED_PROPERTY(data.Invoices),
          total: data.TotalInvoiceCount
        };
      });
    }else{
      this._dashBoardService.getDashboard(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
        this.totalPage = data.TotalInvoiceCount;
        this.invsDataGrid = {
          data: this.appendISCHECKED_PROPERTY(data.Invoices),
          total: data.TotalInvoiceCount
        };
      });
    }
  }

  public onCloseFilterCloseGraph(filter, $event){
    var scope = this;
    this.listFilterCloseGraph = scope.listFilterCloseGraph.filter(function(tabEl){
      return tabEl.id !== filter.id;
    })

    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboard(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
      });
    }else{
      this._dashBoardService.getDashboard(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
      });
    }
  }

  public onCloseInvoiceNos(filter, $event){
    var filterIndex = this.listFilterInvNos.indexOf(filter);
    this.listFilterInvNos.splice(filterIndex, 1);

    this.SEARCH_DASHBOARD();
  }

  public onChangePage2(pageIndex: number) { 
    this.grid2PageNo = pageIndex;
    this.skip = (pageIndex * 10) - 10;    
    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboardPagination(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invoicesList = data;
        
      });
    }else{
      this._dashBoardService.getDashboardPagination(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invoicesList = data;
      });
    }
  }

  
  public setItemsPerPage(event) {
    if(event == "All"){
     this.ngxConfig.itemsPerPage = this.ngxConfig.totalItems
     this.take = this.ngxConfig.totalItems;
    }else{
     this.ngxConfig.itemsPerPage = event
     this.take = event;
    }
    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboardPagination(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invoicesList = data;
      });
    }else{
      this._dashBoardService.getDashboardPagination(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invoicesList = data;
        this.ngxConfig.totalItems = data.TotalInvoiceCount;
      });
    }
  }

  public exportData(){
    let seledtedInvs = Utils.DeepCopy(this.invs);
     var invIds = seledtedInvs.filter(function(invoice) {
      return invoice.IsChecked === true;
    });

    let commaSepInvs = "";
    invIds.forEach(element => {
      commaSepInvs =  commaSepInvs + element.InvoiceNo + ",";
    });

    var filter = { ...this.buildFilters(), CommaSepInvs: commaSepInvs };
    this.export(filter)
  }

  public export(filters){    
    this._dashBoardService.getExportInvoices(filters).subscribe(data => {
      let checkedInv = data.find(item => item.IsChecked === true);
      if(checkedInv){
        data = data.filter(function(invoice) {
          return invoice.IsChecked === true;
        });
      }
      var excelData = [];
      var scope = this;
      var dynamicObj:any = {};
      var columnNames = [];
      data.forEach(value=>{
        dynamicObj = {};
        if(!scope.invoiceGridHideSelectedColumn.InvoiceNo){
          dynamicObj.InvoiceNo = value.InvoiceNo;
          if(!columnNames.includes("Invoice Number")){
            columnNames.push("Invoice Number");
          } 
        }

        if(!scope.invoiceGridHideSelectedColumn.NoOfShipment){
          dynamicObj.NoOfShipment = value.NoOfShipment;
          if(!columnNames.includes("Shipments")){
            columnNames.push("Shipments");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.InvoiceDate){
          dynamicObj.InvoiceDate = value.InvoiceDate;
          if(!columnNames.includes("Invoice Date")){
            columnNames.push("Invoice Date");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.DueDate){
          dynamicObj.DueDate = value.DueDate;
          if(!columnNames.includes("Due Date")){
            columnNames.push("Due Date");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ClientCode){
          dynamicObj.ClientCode = value.ClientCode;
          if(!columnNames.includes("Client Code")){
            columnNames.push("Client Code");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ClientRegion){
          dynamicObj.ClientRegion = value.ClientRegion;
          if(!columnNames.includes("Client Region")){
            columnNames.push("Client Region");
          }
        }


        if(!scope.invoiceGridHideSelectedColumn.ClientCountry){
          dynamicObj.ClientCountry = value.ClientCountry;
          if(!columnNames.includes("Client Country")){
            columnNames.push("Client Country");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ClientCity){
          dynamicObj.ClientCity = value.ClientCity;
          if(!columnNames.includes("Client City")){
            columnNames.push("Client City");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ClientDivision){
          dynamicObj.ClientDivision = value.ClientDivision;
          if(!columnNames.includes("Client Division")){
            columnNames.push("Client Division");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ClientLocation){
          dynamicObj.ClientLocation = value.ClientLocation;
          if(!columnNames.includes("Client Location")){
            columnNames.push("Client Location");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.CarrierCode){
          dynamicObj.CarrierCode = value.CarrierCode;
          if(!columnNames.includes("Carrier Code")){
            columnNames.push("Carrier Code");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.CarrierName){
          dynamicObj.CarrierName = value.CarrierName;
          if(!columnNames.includes("Carrier Name")){
            columnNames.push("Carrier Name");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.CarrierCity){
          dynamicObj.CarrierCity = value.CarrierCity;
          if(!columnNames.includes("Carrier City")){
            columnNames.push("Carrier City");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.CarrierCountry){
          dynamicObj.CarrierCountry = value.CarrierCountry;
          if(!columnNames.includes("Carrier Country")){
            columnNames.push("Carrier Country");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.Currency){
          dynamicObj.Currency = value.Currency;
          if(!columnNames.includes("Currency")){
            columnNames.push("Currency");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.BilledAmount){
          dynamicObj.BilledAmount = value.BilledAmount;
          if(!columnNames.includes("Invoice Amount")){
            columnNames.push("Invoice Amount");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ShipmentMode){
          dynamicObj.ShipmentMode = value.ShipmentMode;
          if(!columnNames.includes("Mode")){
            columnNames.push("Mode");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ServiceLevel){
          dynamicObj.ServiceLevel = value.ServiceLevel;
          if(!columnNames.includes("Service")){
            columnNames.push("Service");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.OriginCountryCode){
          dynamicObj.OriginCountryCode = value.OriginCountryCode;
          if(!columnNames.includes("Origin")){
            columnNames.push("Origin");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.DestinationCountryCode){
          dynamicObj.DestinationCountryCode = value.DestinationCountryCode;
          if(!columnNames.includes("Destination")){
            columnNames.push("Destination");
          }
        }

        if(!scope.invoiceGridHideSelectedColumn.ResolutionReasonCode){
          dynamicObj.ResolutionReasonCode = value.ResolutionReasonCode;
          if(!columnNames.includes("Reason Code")){
            columnNames.push("Reason Code");
          }
        }
        excelData.push(dynamicObj);
      });

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
      (columnNames.length  > 0)? ws.A1.v = columnNames[0]:"";
      (columnNames.length  > 1)? ws.B1.v = columnNames[1]:"";
      (columnNames.length  > 2)? ws.C1.v = columnNames[2]:"";
      (columnNames.length  > 3)? ws.D1.v = columnNames[3]:"";
      (columnNames.length  > 4)? ws.E1.v = columnNames[4]:"";
      (columnNames.length  > 5)? ws.F1.v = columnNames[5]:"";
      (columnNames.length  > 6)? ws.G1.v = columnNames[6]:"";
      (columnNames.length  > 7)? ws.H1.v = columnNames[7]:"";
      (columnNames.length  > 8)? ws.I1.v = columnNames[8]:"";
      (columnNames.length  > 9)? ws.J1.v = columnNames[9]:"";
      (columnNames.length  > 10)? ws.K1.v = columnNames[10]:"";
      (columnNames.length  > 11)? ws.L1.v = columnNames[11]:"";
      (columnNames.length  > 12)? ws.M1.v = columnNames[12]:"";
      (columnNames.length  > 13)? ws.N1.v = columnNames[13]:"";
      (columnNames.length  > 14)? ws.O1.v = columnNames[14]:"";
      (columnNames.length  > 15)? ws.P1.v = columnNames[15]:"";
      (columnNames.length  > 16)? ws.Q1.v = columnNames[16]:"";
      (columnNames.length > 16)? ws.Q1.v = columnNames[16]:"";
      (columnNames.length > 17)? ws.R1.v = columnNames[17]:"";
      (columnNames.length > 18)? ws.S1.v = columnNames[18]:"";
      (columnNames.length > 19)? ws.T1.v = columnNames[19]:"";
      (columnNames.length > 20)? ws.U1.v = columnNames[20]:"";
      (columnNames.length > 21)? ws.V1.v = columnNames[21]:"";

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'Invoices.xlsx');
    });
  }

  public containsOpen(statusNo: Number){
      return others.includes(statusNo);
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.selectedItemInvSort = sort[0].field;
    this.sortOrderValue = sort[0].dir;


    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboard(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
        this.totalPage = data.TotalInvoiceCount;
        this.invsDataGrid = {
          data: this.appendISCHECKED_PROPERTY(data.Invoices),
          total: data.TotalInvoiceCount
        };
      });
    }else{
      this._dashBoardService.getDashboard(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.dashboard = data;
        this.barchartlabels = data.barChartLabels; 
        this.totalPage = data.TotalInvoiceCount;
        this.invsDataGrid = {
          data: this.appendISCHECKED_PROPERTY(data.Invoices),
          total: data.TotalInvoiceCount
        };
      });
    }
}

  onDataHistoryClick(e){
    this.dashboard  = null;
    this.barchartlabels  = null;
    this.SEARCH_DASHBOARD();
  }

  onClickinvoice(type: string){

    this.windowInvoiceStatus = type;
    
    // if(type == 'open'){
    //   this.StatusCodes.push('OPEN')
    //   this.StatusCodes.push('INPROG')
    //   this.listFilter.push({"id":this.listFilter.length,"Code":"INPROG","Name":"In Progress"})
    //   this.listFilter.push({"id":this.listFilter.length,"Code":"OPEN","Name":"OPEN"})
    // }
    
    // if(type == 'webres'){
    //   this.StatusCodes.push('INWEB')
    //   this.listFilter.push({"id":this.listFilter.length,"Code":"INWEB","Name":"In Web Resolution"})
    // }
    // if(type == 'pass'){
    //   this.StatusCodes.push('PASSED')
    //   this.listFilter.push({"id":this.listFilter.length,"Code":"PASSED","Name":"PASSED"})
    // }
    // if(type == 'reject'){
    //   this.StatusCodes.push('REJECTED')
    //   this.listFilter.push({"id":this.listFilter.length,"Code":"REJECTED","Name":"REJECTED"})
    // }

    this.SEARCH_DASHBOARD();  
  }

  formGrid2(data: any){
      this.ngxConfig = {
        itemsPerPage: 10,
        totalItems: data.TotalPages
      }
  }

  formGridData(data: any){
    this.invsDataGrid = {
      data: this.appendISCHECKED_PROPERTY(data.Invoices),
      total: data.TotalPages
    };
  }

  appendISCHECKED_PROPERTY(data: Array<any>){
    return data.map(x => ({...x, IsChecked: false}))
  }

  loadItems(){    
    this.invoices  = {
      data: this.invs.slice(this.skip, this.skip + this.pageSize),
      total: this.invs.length
    }
  }
  
  GET_USERSETTINGS(){
    this._userService.getApplicationSettings().subscribe(response =>
    {
        if(response != null)
        {
          this.userSettings = JSON.parse(response.UserSettings);
          if ('WebResCurrencySelected' in this.userSettings === false) {
            this.userSettings["WebResCurrencySelected"] = {Code:"USD",Name:null} 
          }

          if('InvoiceGridHideSelectedColumn' in this.userSettings === false){
            this.userSettings["InvoiceGridHideSelectedColumn"]  = {InvoiceNo:false,InvoiceDate:false,
              DueDate:false,ClientCode:false,ClientRegion:false,
              ClientCountry:false,ClientCity:true,ClientDivision:true,
              ClientLocation:true,CarrierCode:true,CarrierName:true,
              CarrierCity:false,CarrierCountry:false,Currency:false,
              BilledAmount:false,ShipmentMode:false,ServiceLevel:false,
              OriginCountryCode:false,DestinationCountryCode:false,ResolutionReasonCode:false};
          }

          if('WebResClientSelected' in this.userSettings === false){
            this.userSettings['WebResClientSelected'] = '';
          }
          if('WebResPeriodSelected' in this.userSettings === false ){
            this.userSettings['WebResPeriodSelected'] = '';
          }
          if('GeneralSettings' in this.userSettings === false){
            this.userSettings['GeneralSettings'] = 'General Settings';
          }

          var defaultValues =  JSON.parse(this._cookieService.get("__defaultSettings"));
 
           this.dashboardForm.patchValue({
             client:  defaultValues.client,
             currency:  defaultValues.currency,
             datePeriod: (this.userSettings.WebResPeriodSelected == '' || this.userSettings.WebResPeriodSelected == null)?"THIS_QUARTER":this.userSettings.WebResPeriodSelected        
           });

           this.selectedDisplay = this.userSettings.WebResSettingSelected;
           this.selectedTempValue = this.displayList.filter(x=>x.Code == this.selectedDisplay)[0];
 
         this._cookieService.put("__userSettings", JSON.stringify(this.userSettings));
        }
      });
  }
  public onClickWebresolution(): void {
  }

  public pageChange(state: PageChangeEvent, grid: any = null): void {
    this.take = state.take;      
    this.skip = state.skip;
    this.pageSize = state.take;

    if(this.StatusCodes.length == 0){ //if there is no mo filter reset to default filters
      this._dashBoardService.getDashboardPagination(this.buildFiltersOnInit()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invsDataGrid = {
          data: data,
          total: this.totalPage
        };
      });
    }else{
      this._dashBoardService.getDashboardPagination(this.buildFilters()).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        this.invsDataGrid = {
          data: data,
          total: this.totalPage
        };
      });
    }
  }
  
  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if ((element.nodeName === 'TD' || element.nodeName === 'TH') ) {
        if(element.getElementsByTagName("span").length > 0){
          var temp = element.getElementsByTagName("span")[0] as HTMLElement;
          let elem:Element = temp
          this.tooltipDir.toggle(elem);
        }else{
          this.tooltipDir.hide();
        }
    } else {
        this.tooltipDir.hide();
    }
  }

  refreshList(){  
    this.showList = true; 
  }

  clearFilter(){
    console.log('clear filter')
    this.listFilter = [];
    this.listFilterOpenGraph = [];
    this.listFilterCloseGraph = [];
    this.windowInvoiceStatus = "";

    this.SEARCH_DASHBOARD(true);
    this.setClearFilterStyle();
  }


  openClicked(e: any){
    var scope = this;    
    console.log(e);
    if(e.active.length > 0){

      let dataIndex = e.active[0].datasetIndex;      
      let label = e.event.chart.data.datasets[dataIndex].label;
      
      // console.log(e);
      // console.log(e.event.chart.tooltip.title);
      // console.log(label);
      // console.log(scope)

      // let position = points.indexOf(pointSelected);
      // let label = legends[position].text;

      this.listFilterOpenGraph = [];
      this.StatusCodes = [];
      // scope.StatusCodes.push("OPEN");      

      scope.listFilter.push({"id":this.listFilter.length,"Code":"OPEN","Name":"OPEN"});
      this.listFilter.push({"id":this.listFilter.length,"Code":"INPROG","Name":"In Progress"});

      let title = e.event.chart.tooltip.title;

      if(title.indexOf("+30") > -1){ 
          if(label == "IN PROGRESS"){
            this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS +30","Name":"INPROG"})
          }else if(label == "IN WEB RESOLUTION"){
            this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION +30","Name":"INWEB"})
          }else if(label == "PASSED"){
            this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING +30","Name":"PASSED_AWAIT"})
          }else if(label == "REJECTED"){
            this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING +30","Name":"REJECTED_AWAIT"})
          }
      }

      else  if(title.indexOf("30-10") > -1){
        if(label == "IN PROGRESS"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS 30-10","Name":"INPROG"})
        }else if(label == "IN WEB RESOLUTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION 30-10","Name":"INWEB"})
        }else if(label == "PASSED"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING 30-10","Name":"PASSED_AWAIT"})
        }else if(label == "REJECTED"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING 30-10","Name":"REJECTED_AWAIT"})
        }
      }

      else  if(title.indexOf("10-0") > -1){
        if(label == "IN PROGRESS"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS 10-0","Name":"INPROG"})
        }else if(label == "IN WEB RESOLUTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION 10-0","Name":"INWEB"})
        }else if(label == "PASSED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING 10-0","Name":"PASSED_AWAIT"})
        }else if(label == "REJECTED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING 10-0","Name":"REJECTED_AWAIT"})
        }
      }

      else  if(title.indexOf("0-10") > -1){ 
        if(label == "IN PROGRESS"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS 0-10","Name":"INPROG"})
        }else if(label == "IN WEB RESOLUTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION 0-10","Name":"INWEB"})
        }else if(label == "PASSED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING 0-10","Name":"PASSED_AWAIT"})
        }else if(label == "REJECTED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING 0-10","Name":"REJECTED_AWAIT"})
        }
      }

      else  if(title.indexOf("10-30") > -1){ 
        if(label == "IN PROGRESS"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS 10-30","Name":"INPROG"})
        }else if(label == "IN WEB RESOLUTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION 10-30","Name":"INWEB"})
        }else if(label == "PASSED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING 10-30","Name":"PASSED_AWAIT"})
        }else if(label == "REJECTED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING 10-30","Name":"REJECTED_AWAIT"})
        }
      }
      
      else  if(title.indexOf("60+") > -1){
        if(label == "IN PROGRESS"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN PROGRESS 60+","Name":"INPROG"})
        }else if(label == "IN WEB RESOLUTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"IN WEB RESOLUTION 60+","Name":"INWEB"})
        }else if(label == "PASSED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"PASSED AWAITING 60+","Name":"PASSED_AWAIT"})
        }else if(label == "REJECTED-AWAITING PRODUCTION"){
          this.listFilterOpenGraph.push({"id":this.listFilterOpenGraph.length,"Code":"REJECTED AWAITING 60+","Name":"REJECTED_AWAIT"})
        }
      }      
    }
   
    this.SEARCH_DASHBOARD();
    this.setClearFilterStyle();
  }
  

  closedInvoiceChartClick(e: any){
    console.log(e)

    if(e.active.length > 0){

      var points = [];

      // var pointSelected = e.active[0]._chart.tooltip._model.caretY;
      var pointSelected = e.event.chart.tooltip.caretY;

      // var legends = e.active[0]._chart.legend.legendItems.filter(x => !x.hidden);
      var legends = e.event.chart.legend.legendItems.filter(x => !x.hidden);

      for (var i = 0; i < e.active.length; ++i) {
        points.push(e.active[i].element.y);
      }

      let position = points.indexOf(pointSelected); 
      let label = legends[position].text; //get the tooltip test

      console.log(position);
      console.log(label);

      // this.listFilterCloseGraph = [];
      // var currentYear = new Date().getFullYear();
      // if(this.dashboardForm.get('datePeriod').value == "LAST_YEAR")
      // {
      //   currentYear = new Date().getFullYear() -1;
      // }else if(this.dashboardForm.get('datePeriod').value != "ALL"){
      //   currentYear = new Date().getFullYear();
      // }

      // this.StatusCodes = [];
      // if(label == "Passed"){
      //   this.StatusCodes.push("PASSED");
      //   this.listFilter.push({"id":this.listFilter.length,"Code":"PASSED","Name":"PASSED"})
      // }else {
      //   this.StatusCodes.push("REJECTED");
      //   this.listFilter.push({"id":this.listFilter.length,"Code":"REJECTED","Name":"REJECTED"})
      // }
      // this.listFilterCloseGraph.push({"id":this.listFilterCloseGraph.length,"Code":e.active[0]._chart.tooltip._model.title.toLocaleString(),"Name":e.active[0]._chart.tooltip._model.title + "-" + currentYear})
    
    }

    this.SEARCH_DASHBOARD();
    this.setClearFilterStyle();
  }

  formatchangeKendo(e){

  }

  // Remove Filters
  removeStatusCode(filter:any, status: string){

  }
  //selection template
  public selectionDisplay(temp){
    this.selectedDisplay = temp.Code;
  }
     //selection invoice sort
  public selectionChangeInvSort(value){
      this.sortAscending(value);
  }

  sortAscending(value){

  }
  sortDescending(value){
    
  }
  
  changeSortingAsc(): void{
    
  }

  changeSortingDesc(): void{
 
  }


  checkBoxLabelOpenInvoiceChange(index: number){
    var scope = this;
    scope.StatusCodes = [];

    if(this.dashboard.BarSelected[index].hidden){
      this.dashboard.BarSelected[index].hidden = false;
    }else{
      this.dashboard.BarSelected[index].hidden = true;
    }

    this.dashboard.BarSelected.forEach(element => {
      if(element.hidden != true){
        if(element.label == 'REJECTED'){
          scope.StatusCodes.push('REJECTED_AWAIT');
        }else if(element.label == 'PASSED'){
          scope.StatusCodes.push('PASSED_AWAIT');
        }else if(element.label == 'IN WEB RESOLUTION'){
          scope.StatusCodes.push('INWEB');
        }else if(element.label == 'MY WEB RESOLUTION'){
          scope.StatusCodes.push('MYWEB');
        }else if(element.label == 'IN PROGRESS'){
          scope.StatusCodes.push('INPROG');
        }
      }
    });

    this.SEARCH_DASHBOARD();
    this.setClearFilterStyle();
  }

  checkBoxLabelInvoiceHistoryChange(filter: any){
    filter.hidden = !filter.hidden;
    this.SEARCH_DASHBOARD();
  }

  public setClearFilterStyle(){
    if(this.listFilter.length > 0 || this.listFilterOpenGraph.length > 0 || this.listFilterCloseGraph.length > 0 || this.windowInvoiceStatus != ""){
            this.clearFilterStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(174deg) brightness(104%) contrast(81%)'};
            this.clearFilterStyle = { color: 'rgb(53, 54, 54)',cursor:'pointer' };
    }else{
      this.clearFilterStyle = { 'background': '#ffffff',color: 'rgb(159, 160, 160)',cursor:'auto','pointer-events':'none' };
      this.clearFilterStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
    }
  }
  onClickinvoice1(dataItem: any){
    let invoiceId = dataItem.Id;
    this.processOnClickInvoice(invoiceId);
    this._appService.getAllocation(invoiceId).pipe(takeUntil(this.unsubscribe$)).subscribe((data)=>{
      this.allocation = data.Value;
    });
  }
  public processOnClickInvoice(invoiceId){
    let theFile
  
    this._webResService.getInvoiceByIdPromise(invoiceId)
    .subscribe((data) => {
      this.inv = data;
      this.showList = false;
      this.shipmentGridView = {
          data: this.inv.Shipments.slice(this.skip, this.skip + this.pageSize),
          total: this.inv.Shipments.length
      };
      this.invShipment = data.Shipments;
      this.showIframeLoader = true;
      this._cd.detectChanges();

      this._webResService.getWebResAttachmentOpenPDF(this.inv.InvoiceFile,"n",invoiceId).pipe(takeUntil(this.unsubscribe$)).subscribe((blobObj) => {
        theFile = new Blob([blobObj], { type: 'application/octet-stream' });
        this.noimg.nativeElement.style.display = 'none';
        this.invoicePDF.nativeElement.style.display = 'block';
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(theFile, this.inv.InvoiceFile+'.pdf');
        } else {
          var url = window.URL.createObjectURL(blobObj);
          window.open(url, "invoicePDFframe");
        }
        this.showIframeLoader = false;
      },
        (err) => {
            console.log(err);
            this.style ='<div style="margin-top: -50%;padding-top: 20px;overflow:hidden"><center><img src="/assets/images/alert/No-image-available.png"></center></div>';
            this.noimg.nativeElement.innerHTML = this.style;
            this.invoicePDF.nativeElement.style.display = 'none';
            this.showIframeLoader = false;
        });
        },
        (err) => {
        if(err.status === 400){
          this._messageBox.open(err.error.Message);
          console.log(err.error);
        }
      });
  
    }
  public viewClickDisplay1(data){
    let invoiceId = data;
    let theFile
   this._webResService.getInvoiceByIdPromise(invoiceId)
   .subscribe((data) => {
    this.showList = false;
     this.inv = data;
     this.shipmentGridView = {
         data: this.inv.Shipments.slice(this.skip, this.skip + this.pageSize),
         total: this.inv.Shipments.length
     };
     this.invShipment = data.Shipments;
     this.showIframeLoader = true;

     this._cd.detectChanges();

     this._webResService.getWebResAttachmentOpenPDF(this.inv.InvoiceFile,"n",invoiceId).pipe(takeUntil(this.unsubscribe$)).subscribe((blobObj) => 
     {
       theFile = new Blob([blobObj], { type: 'application/octet-stream' });
       this.noimg.nativeElement.style.display = 'none';
       this.invoicePDF.nativeElement.style.display = 'block';
       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
         window.navigator.msSaveOrOpenBlob(theFile, this.inv.InvoiceFile+'.pdf');
       } else {
        var url = window.URL.createObjectURL(blobObj);
         window.open(url, "invoicePDFframe");
       }
       this.showIframeLoader = false;

     },
     (err) => {
         this.style ='<div style="margin-top: -50%;padding-top: 20px;overflow:hidden"><center><img src="/assets/images/alert/No-image-available.png"></center></div>';
         this.noimg.nativeElement.innerHTML = this.style;
         this.invoicePDF.nativeElement.style.display = 'none';
         this.showIframeLoader = false;
     });

     this._appService.getAllocation(invoiceId).subscribe((data)=>{
      this.allocation = data.Value;
    });
   },
   (err) => {
     if(err.status === 400){
       this._messageBox.open(err.error.Message);
       console.log(err.error);
     }
   });
  }

  public onClicksummary(): void {
    this.showList = true;
    this.refreshList();
  }

  public checkBoxSelectAll(event) {
    const checked = event;
    this.invs.forEach(item => item.IsChecked = checked);
    if(checked){
      this.iSSlectedAllChecked = true;
      this.selectAllStyle  = { 'background': '#163e70',color: '#fff' };
      this.actionStyle  = { color: 'rgb(53, 54, 54)',cursor:'pointer'  };
      this.exportStyle = { color: 'rgb(53, 54, 54)',cursor:'pointer' };
      this.exportStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(174deg) brightness(104%) contrast(81%)'};
      this.actionStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(174deg) brightness(104%) contrast(81%)'};
      this.actionBtn = false;
     this.onFilterStyle();
    }else{
      this.iSSlectedAllChecked = false;
      this.selectAllStyle  = {'background': 'rgb(251, 251, 251)',color: 'rgb(159, 160, 160)' }
      this.actionStyle  = { 'background': '#ffffff',color: 'rgb(159, 160, 160)',cursor:'auto','pointer-events':'none'  };
      this.exportStyle = { 'background': '#ffffff',color: 'rgba(0, 0, 0, 0.39)',cursor:'auto' };
      this.exportStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
      this.actionStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
      this.offFilterStyle();
      this.actionBtn = true;
    }
  }

  private onFilterStyle(){
    this.filterSearchStyle  = { 'background': '#163e70',color: '#fff' };
    this.hasFilter = true;
  }

  private offFilterStyle(){
    let checkedInv = this.invs.find(item => item.IsChecked === true) ;
    if(this.listFilter.length > 0||this.listFilterCloseGraph.length > 0 ||
        this.listFilterOpenGraph.length > 0 || checkedInv){
        this.hasFilter = true;  
        return;
    }
    this.hasFilter = false;
    this.filterSearchStyle  = {'background': 'rgb(251, 251, 251)',color: 'rgb(159, 160, 160)' }
    this.actionStyle  = { 'background': '#ffffff',color: 'rgba(0, 0, 0, 0.39)',cursor:'auto','pointer-events':'none'  };
    this.exportStyle = { 'background': '#ffffff',color: 'rgba(0, 0, 0, 0.39)',cursor:'auto' };
  }

  public checkBoxChanges(event) {
    let checkedInv = this.invs.find(item => item.IsChecked === true);
    if(checkedInv){
      this.actionStyle  = { color: 'rgb(53, 54, 54)',cursor:'pointer'  };
      this.exportStyle = { color: 'rgb(53, 54, 54)',cursor:'pointer' };
      this.exportStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(174deg) brightness(104%) contrast(81%)'};
      this.actionStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(174deg) brightness(104%) contrast(81%)'};
      this.actionBtn = false;
    }else{
      this.actionStyle  = { 'background': '#ffffff',color: 'rgb(159, 160, 160)',cursor:'auto','pointer-events':'none'  };
      this.exportStyle = { 'background': '#ffffff',color: 'rgba(0, 0, 0, 0.39)',cursor:'auto' };
      this.exportStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
      this.actionStyleIcon = {'filter':'invert(27%) sepia(56%) saturate(5%) hue-rotate(164deg) brightness(1044%) contrast(81%)'};
      this.actionBtn = true;
    }
  }

  // public openDownload(invoiceId){
  //   const modal: any =   this._messageBox.openSMoModal(DownloadFileModalComponent);
  //   let modalComponent = modal.componentInstance;
  //   modalComponent.invoiceId = invoiceId;
  // }

  public openInvoice(filename,invoiceId){
    this._dashBoardService.getWebResAttachmentOpenPDF(filename,"n",invoiceId).pipe(takeUntil(this.unsubscribe$)).subscribe((blobObj) =>{
      var url = window.URL.createObjectURL(blobObj);
      window.open(url);
    },
    (err) => {
      this._messageBox.open("No Invoice Image Available!");
      console.log("error: " + err.error);
    });
  }

  public viewAttachDocument(invoiceId){
    const modal: any =   this._messageBox.openLargeCustoModal(ViewAttachmentModalComponent);
    // let modalComponent = modal.componentInstance;
    // modalComponent.commaSeparatedInvId = this.inv.Id.toString();
  }

  public openDownload(invoiceId){
    const modal: any =   this._messageBox.openSMoModal(DownloadFileModalComponent);
    let modalComponent = modal.componentInstance;
    modalComponent.invoiceId = invoiceId;
  }

  public attachDocument(){

    const modal: any =   this._messageBox.openCustoModal(AttachComponent);
    let modalComponent = modal.componentInstance;
    modalComponent.commaSeparatedInvId = this.inv.Id.toString();
  }

  public removeSelectedFile(invoiceAttachment) {
    this._webResService.removeFile(invoiceAttachment.InvoiceId,invoiceAttachment.RawFileName).subscribe((data) => { });
      this.fileAttachment  =  this.fileAttachment.filter(function(inv){
      return inv.RawFileName != invoiceAttachment.RawFileName
    });
  }
  public sendCTGlobal(): void {
    if(this.comment == " " || this.comment == null || this.comment == 'undefined') {
        this._messageBox.open("Please enter your comment!");
        return;
    }
    const modal: any = this._messageBox.openCustoModal(SendCtGlobalModalComponent);
    let instance = modal.componentInstance;
    instance.eventEmitter.subscribe((isSend) => {
      if(isSend){
        this._webResService.sendCommentToCarrierClient([this.inv.Id],MessageToBeDirectedTo.CTGF,this.comment).subscribe((data) => {
          this._messageBox.open("Successfully Sent");
          this.onClicksummary();
        });
      }
    })
  }


  getCountryFlag(data: any){
    return './assets/logos/flags/' + data.toLowerCase() + '.png';
  }

  showShipmentDetails(shipment: any){
    var scope = this;
    this.isVisibleShipment = true;
    this._webResService.getShipmentInformation(shipment.Id).pipe(takeUntil(this.unsubscribe$)).subscribe(x => {
      this.titleShipment = `Shipment ID ${shipment.Id}`
      this.shipmentInformation = x;
      scope.gridViewInvoiceSIDs = {
        data: scope.gridViewInvoiceSIDsCopy.InvoiceSIDs,
        total: scope.gridViewInvoiceSIDsCopy.InvoiceSIDs.length
      };

      scope.gridViewInvoiceClientFields = {
        data: scope.gridViewInvoiceClientFieldsCopy.InvoiceClientFields,
        total: scope.gridViewInvoiceClientFieldsCopy.InvoiceClientFields.length
      };

      scope.gridViewInvoiceUoms = {
        data: scope.gridViewInvoiceUomsCopy.InvoiceUoms, 
        total: scope.gridViewInvoiceUomsCopy.InvoiceUoms.length
      };

    })
  }
  public exporShipmentData(){
    var excelData = [];
    this.invShipment.forEach((value, index)=>{
      let uomDesc = (value.UnitsOfMeasureDescription.length > 0)? value.UnitsOfMeasureDescription[0]:"";
      let uomAmount = (value.UnitsOfMeasureAmount.length > 0)? value.UnitsOfMeasureAmount[0]:0;
      let uomDesc1 = (value.UnitsOfMeasureDescription.length > 1)? value.UnitsOfMeasureDescription[1]:"";
      let uomAmount1 = (value.UnitsOfMeasureAmount.length > 1)? value.UnitsOfMeasureAmount[1]:0;
      let uomDesc2 = (value.UnitsOfMeasureDescription.length > 2)? value.UnitsOfMeasureDescription[2]:"";
      let uomAmount2 = (value.UnitsOfMeasureAmount.length > 2)? value.UnitsOfMeasureAmount[2]:0;
      excelData.push(
            {
            'Id':index + 1,
            'Shipment Id':value.Id,
            'ShipmentMode.Name':value.ShipmentMode,
            'ServiceLevel.Name':value.ServiceLevel,
            'OriginCountryCode':value.OriginCountryCode,
            'DestinationCountryCode':value.DestinationCountryCode,
            'ShipmentCurrency.Code':value.ShipmentCurrencyCode,
            'BilledAmount':value.BilledAmount,
            'Freight':value.Freight,
            'FuelSurcharge':value.FuelSurcharge,
            'Surcharge':value.Surcharge,
            'Warehouse':value.Warehouse,
            'GroupDutyTax':value.GroupDutyTax,
            'Local':value.Local,
            'Other':value.Other,
            'UOM.Description':uomDesc,
            'Amount':uomAmount,
            'UOM.Description1':uomDesc1,
            'Amount1':uomAmount1,
            'UOM.Description3':uomDesc2,
            'Amount3':uomAmount2,
          }
        )
    });
    
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    ws.A1.v = "Shipment Number";
    ws.B1.v = "Shipment ID";
    ws.C1.v = "Mode";
    ws.D1.v = "Origin";
    ws.E1.v = "ServiceLevel";
    ws.F1.v = "Destination";
    ws.G1.v = "Shipment Currency";
    ws.H1.v = "Billed Amount";
    ws.I1.v = "Freight";
    ws.J1.v = "Fuel Surcharge";
    ws.K1.v = "Surcharge";
    ws.L1.v = "Warehouse";
    ws.M1.v = "GroupDutyTax";
    ws.N1.v = "Local";
    ws.O1.v = "Other";
    ws.P1.v = "Uom Name1";
    ws.Q1.v = "Uom Value1";
    ws.R1.v = "Uom Name2";
    ws.S1.v = "Uom Value2";
    ws.T1.v = "Uom Name3";
    ws.U1.v = "Uom Value3";
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Shipment Information');
    XLSX.writeFile(wb, 'shipmentInformation.xlsx');
  }
  
  dataOut(data: any){

    data.searchText.split(',').forEach(invoice => {
      this.listFilterInvNos.push(invoice);
    });

    var invoices:Array<any> = [];
    for (var key of Object.keys(data.list)){
      invoices.push(data.list[key]);
    }
    this.SEARCH_DASHBOARD();
  }
  
  GET_STATUS_CODES(): Array<string> {
    
    var statuses: Array<any> = this.dashboard?.BarSelected;
    var closedInvoices: Array<any> = this.dashboard?.barChartData;
    var TEMP_STATUSCODE: Array<string> = [];


    if(statuses == null || statuses.length == 0 && this.windowInvoiceStatus == ""){
      return this.ALL_STATUSCODES;
    }

    if(this.windowInvoiceStatus){
      if(this.windowInvoiceStatus == 'pass') TEMP_STATUSCODE.push('PASSED');
      if(this.windowInvoiceStatus == 'reject') TEMP_STATUSCODE.push('REJECTED');
      if(this.windowInvoiceStatus == 'webres') TEMP_STATUSCODE.push('INWEB');
      if(this.windowInvoiceStatus == 'open') TEMP_STATUSCODE.push('OPEN');
      return TEMP_STATUSCODE;
    }

    if(this.listFilterOpenGraph.length > 0){
      TEMP_STATUSCODE.push(this.listFilterOpenGraph[0].Name);
      return TEMP_STATUSCODE;
    }



    if(statuses.find(e => e.label === 'REJECTED-AWAITING PRODUCTION' && e.hidden == false))
      TEMP_STATUSCODE.push('REJECTED_AWAIT');
    if(statuses.find(e => e.label === 'PASSED-AWAITING PRODUCTION' && e.hidden == false))
      TEMP_STATUSCODE.push('PASSED_AWAIT');
    if(statuses.find(e => e.label === 'IN WEB RESOLUTION' && e.hidden == false))
      TEMP_STATUSCODE.push('INWEB');
    if(statuses.find(e => e.label === 'MY WEB RESOLUTION' && e.hidden == false))
      TEMP_STATUSCODE.push('MYWEB');
    if(statuses.find(e => e.label === 'IN PROGRESS' && e.hidden == false))
      TEMP_STATUSCODE.push('INPROG');

    if(closedInvoices.find(e => e.label === 'PASSED' && e.hidden == false))
      TEMP_STATUSCODE.push('PASSED');
    if(closedInvoices.find(e => e.label === 'REJECTED' && e.hidden == false))
      TEMP_STATUSCODE.push('REJECTED');
    
    TEMP_STATUSCODE.push('OPEN');
    return TEMP_STATUSCODE;
  }

  SEARCH_DASHBOARD(resetFilters: boolean = false): void {

    var filter = { };
    if(resetFilters){
      filter = { ... this.buildFilters(),  StatusCodes: this.ALL_STATUSCODES };
    }      
    else
      filter = this.buildFilters();

    this._dashBoardService.getDashboard(filter).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      console.log(data)
      this.dashboard            = data;
      this.barchartlabels       = data.barChartLabels; 
      this.totalPage            = data.TotalInvoiceCount;
      this.invs                 = data.Invoices
      this.invoicesList         = data.Invoices;
      this.ngxConfig.totalItems = data.TotalInvoiceCount;

      this.invsDataGrid = {
        data: this.invs,
        total: data.TotalInvoiceCount
      };
    });
  }

}

